import { useMemo, useState } from "react";
import getModuleName from "utils/getModuleName";

import Button from "components/Button";
import validateFields from "./validateFields";
import "./steps-box.css";

export default function StepsBox({ steps, params, errors, setErrors, onChange, onSubmit, editionData, initialStep }) {

   const module = getModuleName();
   const [step_num, setStepNum] = useState(initialStep || 1);
   const [selectAllOn, setSelectAllOn] = useState(false);

   const Step = useMemo(() => {
      return steps[step_num - 1] || {};
   }, [steps, step_num]);

   const onNextStep = () => {
      const validation_check = !!Step.validation_fields
         ? validateFields(Step.validation_fields, params)
         : { is_valid: true };

      if (validation_check.is_valid) {
         setErrors({});

         if (steps.length === step_num) {
            onSubmit && onSubmit();
            return;
         }

         setStepNum(s => s + 1);
      } else {
         setErrors(validation_check.errors);
      }
   }

   const onSelectAll = () => {
      setSelectAllOn(prev => !prev);
   }

   const handleDownloadRawData = () => {
      if (editionData?.raw_data_file_url) {
         window.open(editionData.raw_data_file_url, '_blank');
      }
   }

   // Sprawdź czy powinien być wyświetlony przycisk "Pobierz surowe dane"
   const shouldShowDownloadButton = useMemo(() => {
      if (!editionData?.raw_data_file_url) return false;
      
      // Dla UD: w Step1 po wyborze edycji
      if (module === "UD" && step_num === 1 && params.edition) {
         return true;
      }
      
      // Dla AZZKU i AZZKU_TOP: w Step1 (editionData jest zawsze dostępne)
      if ((module === "AZZKU" || module === "AZZKU_TOP") && step_num === 1 && editionData) {
         return true;
      }
      
      return false;
   }, [module, step_num, params.edition, editionData]);

   return (
      <div className="steps-box">
         <div className="steps-box-top">
            <h3> {Step.title} </h3>
            <div className="steps-box-top-actions">
               { shouldShowDownloadButton && (
                  <Button
                     icon="download"
                     label="Pobierz surowe dane"
                     onClick={handleDownloadRawData}
                     extra_classes="download-raw-data"
                  />
               )}
            </div>
         </div>

         {Step?.Content &&
            <Step.Content
               params={params}
               errors={errors}
               onChange={onChange}
               selectAllOn={selectAllOn}
            />
         }

         <div className="steps-box-bottom">
            {Step.prev_btn &&
               <Button
                  icon="prev"
                  label={Step.prev_btn}
                  extra_classes="violet"
                  onClick={() => setStepNum(s => s - 1)}
               />
            }

            {Step.next_btn &&
               <Button
                  icon="next"
                  label={Step.next_btn}
                  onClick={onNextStep}
               />
            }
         </div>
      </div>
   )
}